import { VehicleBatchEditActions } from "../BatchEdit/flux";
import { ErrorActions } from "../../../../flux/Error";
import { ListStore, SelectedItemsStore } from "../../../../flux/Grid";
import { Vehicle } from "../../../../../models";
import { StatBuilder } from "../../../../../utils/StatBuilder";
import { appNavigator } from "../../../../routes";

export class ShowVehicleGroupActionsCommand
{
    private readonly groupEditActions = new VehicleBatchEditActions();
    private readonly errorActions = new ErrorActions();
    
    constructor(
        private listStore: ListStore<Vehicle>,
        private selectedItemsStore: SelectedItemsStore<Vehicle>,
        private errorDispatchToken: string)
    {
    }

    execute = () => {
        const vehicleIds = this.selectedItemsStore.toArray();
        const selected = new Set<string|number>(vehicleIds);
        const statBuilder = new StatBuilder<string>();
        this.listStore.getState().items
            .filter(item => selected.has(item.id))
            .forEach(item => statBuilder.inc(...item.Tags));
        this.groupEditActions.setIds(vehicleIds);
        this.groupEditActions.setAvailableTagsStat(statBuilder.stat);
        this.errorActions.clearError(this.errorDispatchToken);
        appNavigator.goToVehicleGroupActionsPage();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Vehicle/commands/ShowVehicleGroupActionsCommand.ts